// src/frontend_react/src/components/ui/Input/Input.js
import React from 'react';
import styles from './Input.module.css';

const Input = ({
  id,
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  readOnly = false,
  maxLength,
  min,
  max,
  step,
  isTextarea = false,
  rows,
  error,

  hintText,
  className = '',
  labelClassName = '',
  inputClassName = '',
  wrapperClassName = '',
  style,
  alignSelf,
  flexGrow,
  ...rest
}) => {
  const inputId = id || name;

  const wrapperStyle = { ...style };
  if (alignSelf) wrapperStyle.alignSelf = alignSelf;
  if (flexGrow) wrapperStyle.flexGrow = flexGrow;

  return (
    <div
      className={`${styles.inputWrapper} ${error ? styles.errorState : ''} ${wrapperClassName} ${className}`}
      style={wrapperStyle}
    >
      {label && (
        <label htmlFor={inputId} className={`${styles.label} ${labelClassName}`}>
          {label}
          {required && <span className={styles.requiredIndicator}>*</span>}
        </label>
      )}
      {isTextarea ? (
        <textarea
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          readOnly={readOnly}
          maxLength={maxLength}
          rows={rows || 3}
          className={`${styles.input} ${styles.textarea} ${inputClassName}`}
          aria-invalid={!!error}
          aria-describedby={hintText || error ? `${inputId}-description` : undefined}
          {...rest}
        />
      ) : (
        <input
          id={inputId}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          readOnly={readOnly}
          maxLength={maxLength}
          min={min}
          max={max}
          step={step}
          className={`${styles.input} ${inputClassName}`}
          aria-invalid={!!error}
          aria-describedby={hintText || error ? `${inputId}-description` : undefined}
          {...rest}
        />
      )}
      {(hintText || error) && (
        <div id={`${inputId}-description`} className={styles.descriptionArea}>
            {error && <p className={styles.errorMessageText}>{typeof error === 'string' ? error : 'Invalid input'}</p>}
            {!error && hintText && <p className={styles.hintText}>{hintText}</p>}
        </div>
      )}
    </div>
  );
};

export default Input;